import type { MouseEventHandler } from "react";
import { ChromeTokens } from "../chrome/tokens";
import { Icon } from "../chrome/Icon";

/** The card form's submit, wherever the form puts it: in the form, or the sheet's footer. */
export function CardSubmitButton({ label, waiting, disabled, onClick }: {
  label: string;
  waiting: boolean;
  disabled: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      style={{
        width: "100%",
        minHeight: 48,
        fontSize: 16,
        fontWeight: 800,
        fontFamily: ChromeTokens.font.ui,
        border: "none",
        borderRadius: ChromeTokens.radius.pill,
        cursor: disabled ? "not-allowed" : "pointer",
        background: ChromeTokens.color.sun,
        color: ChromeTokens.color.ink,
        boxShadow: ChromeTokens.shadow.soft,
        opacity: disabled ? 0.55 : 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: ChromeTokens.spacing.sm,
      }}
    >
      {waiting ? (
        <>
          <span className="wbm-billing-spin" aria-hidden="true" /> One moment…
        </>
      ) : (
        <>
          <Icon name="lock" size={16} stroke={ChromeTokens.color.ink} /> {label}
        </>
      )}
    </button>
  );
}
